import { AlarmOffIcon } from './AlarmOffIcon';

/**
 * author: Google
 * id DD224DD6-9A65-47AB-8838-90FE346A7768
 * name alarm-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alarm-off.svg
 * tags
 * - Date / Time 
 */
export const AlarmClockOffIcon = AlarmOffIcon;
export default AlarmClockOffIcon